import { render } from "./ModalQbo.vue?vue&type=template&id=260def6f&scoped=true"
import script from "./ModalQbo.vue?vue&type=script&lang=js"
export * from "./ModalQbo.vue?vue&type=script&lang=js"

import "./ModalQbo.vue?vue&type=style&index=0&id=260def6f&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\tink\\tink-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-260def6f"]])

export default __exports__